<template>
  <div>
    <headnavigation :flow="flow" />
    <hr />
    <agent-form />
  </div>
</template>
<script>
//load the form for creating and editing lmt
import AgentForm from "../../../components/lmt/AgentForm";
import CryptoAgentForm from "../../../components/crypto/lmt/AgentForm";

export default {
  components: {
    "agent-form": (process.env.VUE_APP_SYSTEM == "crypto") ? CryptoAgentForm : AgentForm
  },
  data() {
    return {
      flow: [
        { text: this.$tc('general.store_agent', 2), link: "/lmt/agents" },
        { text: this.$t('general.edit_agent') }
      ]
    };
  }
};
</script>